<template>
 <section>
    <Header :user="user" />
    <main class="main animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
      <div class="contenedor py-0">
         <div class="row px-0 py-0">
            <div class="col-12 px-2 py-0">
              <Performances />
            </div>
        </div>
        </div>
    </main>
 </section>
</template>

<script>

import Performances from "@/components/Agencies/Performances.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: 'AllPerformances',
  components: {
    Performances
  },
  mounted() {
    this.setInfoHeader();
  },
  data() {
    return {

    };
  },
    computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
    methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },

    setInfoHeader() {
      switch (parseInt(this.$route.params.item)) {
          case 21:
            this.$emit(
              "updateHeader",
              "Orders with more than 30 days of prospecting, at least 1,500 engaged contacts and a profitability of less than 0."
            );
            break;

          case 25:            
            this.$emit(
              "updateHeader",
              "Orders with at least 6 days of prospecting whose available contacts are fewer than 200."
            );
            break;
          
          case 32:            
            this.$emit(
              "updateHeader",
              "Orders with at least 30 days of prospecting, an operating margin of over 70% and a conversion rate of over 0.05%."
            );
            break;
        default:
          break;
      }
    },
    }
};
</script>
